import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function generateExcel(name, data, headerTransposer) {
  const { data: reportData } = await axios(
    `${REACT_APP_API}/api/report/generateExcel`,
    {
      method: 'POST',
      responseType: 'blob',
      timeout: 300000, // 5 minutos
      data: {
        name,
        data,
        headerTransposer
      }
    }
  )

  return reportData
}
